import React from 'react';
import { GridPanelControl } from 'features/layout/grid-panel/GridPanelControl';
import { useLockContentControl } from 'features/layout/grid-panel/controls/GridPanelLockControl/useLockContentControl';
import { alpha } from '@mui/material/styles';

export const GridPanelLockControl = () => {
  const { controlEnabled, isCurrentContentLocked, handleClick, label, tooltip, icon } =
    useLockContentControl();

  if (!controlEnabled) {
    return null;
  }

  return (
    <GridPanelControl
      tooltip={tooltip}
      aria-label={label}
      icon={icon}
      onClick={handleClick}
      sx={
        isCurrentContentLocked
          ? [
              (theme) => ({
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.common.white,
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.9),
                },
              }),
            ]
          : undefined
      }
    />
  );
};
